import { SensorInjectionStateType } from './state'

export interface SensorInjectionGettersType {
  getSensorInjectionById: (state: SensorInjectionStateType, id: string) => SensorInjectionStateType['sensorInjection']
  getSensorInjectionsBySensorSettingId: (state: SensorInjectionStateType, sensorSettingId: string) => SensorInjectionStateType['sensorInjections']
  getSensorInjectionsByType: (state: SensorInjectionStateType, type: string) => SensorInjectionStateType['sensorInjections']
  getSensorInjectionsByCommandType: (state: SensorInjectionStateType, commandType: string) => SensorInjectionStateType['sensorInjections']
  getActiveSensorInjections: (state: SensorInjectionStateType) => SensorInjectionStateType['sensorInjections']
  getReliableSensorInjections: (state: SensorInjectionStateType) => SensorInjectionStateType['sensorInjections']
  getSensorInjectionsRequiringAck: (state: SensorInjectionStateType) => SensorInjectionStateType['sensorInjections']
}

export const SensorInjectionGetters = {
  getSensorInjectionById: (state: SensorInjectionStateType) => (id: string) => {
    return state.sensorInjections.find(sensorInjection => sensorInjection.id === id)
  },
  getSensorInjectionsBySensorSettingId: (state: SensorInjectionStateType) => (sensorSettingId: string) => {
    return state.sensorInjections.filter(sensorInjection => sensorInjection.sensorSettingId === sensorSettingId)
  },
  getSensorInjectionsByType: (state: SensorInjectionStateType) => (type: string) => {
    return state.sensorInjections.filter(sensorInjection => sensorInjection.type === type)
  },
  getSensorInjectionsByCommandType: (state: SensorInjectionStateType) => (commandType: string) => {
    return state.sensorInjections.filter(sensorInjection => sensorInjection.commandType === commandType)
  },
  getActiveSensorInjections: (state: SensorInjectionStateType) => {
    return state.sensorInjections.filter(sensorInjection => sensorInjection.active)
  },
  getReliableSensorInjections: (state: SensorInjectionStateType) => {
    return state.sensorInjections.filter(sensorInjection => sensorInjection.isReliable())
  },
  getSensorInjectionsRequiringAck: (state: SensorInjectionStateType) => {
    return state.sensorInjections.filter(sensorInjection => sensorInjection.requiresAck)
  },
}
